const sanitizeUrlRegex = /.+\/\/|www.|(\/[a-zA-Z0-9]{0,})/gm;

export const formatUrl: (url: string) => string = url => url.replace(sanitizeUrlRegex, '');
